(function () {
	'use strict';

	angular
		.module('wizard-future7.directives')
		.directive('header', Header)

	/** @ngInject */
	function Header(PATHS) {
		function HeaderController($state, $timeout, $scope, $rootScope, HelperService) {
			const vm = this;

			$scope.$watch(
				() => $rootScope.$root.currentState,
				value => vm.hide = value == 'default.countdown' || value == 'default.ebook' || value == 'default.not-found' ? true : false
			);

			vm.onSelectMenu = (param) => {
				$state.go(`default.home`);

				$timeout(() => HelperService.scrollTo(`#${param}`), 100);
			}

			init();

			function init() {

			}

		}

		return {
			bindToController: true,
			controller: HeaderController,
			controllerAs: 'vm',
			restrict: 'AE',
			templateUrl: `${PATHS.PHYSICAL}/directives/header/header.html`,
			scope: {}
		}
	}
}());